<template>
  <div class="count-outter">
    <div class="icon-outter">
        <div class="icon-rotate">
            <img src="@/assets/icon-outter.svg" alt="">
        </div>
        <div class="icon">
            <slot name="icon">
                <img src="@/assets/icon1.svg" alt="">
            </slot>
        </div>
    </div>
    <div class="text-outter">
        <div class="text-num">
            <slot name="count">1000</slot>
        </div>
        <div class="text">
            <slot name="text">院校总数</slot>
        </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.text {
    font-size: 14px;
}
.text-num {
    font-size: 35px;
}
.text-outter {
    width: 110px;
}
.count-outter {
    width: 200px;
    display: flex;
    color: white;
    flex-flow: row;
    justify-content: space-around;
    align-items: center;
}
@keyframes iconOutter {
   0% {
     transform: rotate(0deg);
   }
 
   100% {
     transform: rotate(360deg);
   }
}
img {
    display: block;
    width: 100%;
    height: 100%;
}

.icon-outter {
    width: 62px;
    height: 62px;
    position: relative;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
}
.icon-rotate {
    width: 100%;
    height: 100%;
    display: block;
    animation: iconOutter 1.2s linear infinite;
    position: absolute;
    left: 0;
    top: 0;
}
.icon {
    width: 20px;
}

</style>